import * as Sentry from '@sentry/react';
import { DropdownMenu } from '@ui-components/neo.tax';
import * as React from 'react';

import { useUpdateCompanyQuestion, ChoiceCode } from '@neo.tax/shared';

import { MissingAvailableChoices } from './company-info.errors';
import { QuestionProps } from './company-info.types';

export const DropdownFieldString: React.FC<QuestionProps> = ({ question }) => {
  const updateCompanyQuestion = useUpdateCompanyQuestion(question.id, question.questionId);

  if (!question.questionChoices) {
    Sentry.captureException(new MissingAvailableChoices(question));
    return null;
  }

  const { questionChoices } = question;

  return (
    <DropdownMenu
      options={questionChoices.map(({ choiceCode, displayText }) => ({
        value: choiceCode,
        label: displayText,
      }))}
      value={questionChoices.find(({ selected }) => selected)?.choiceCode ?? null}
      onChange={(newChoiceCode: ChoiceCode): void => {
        updateCompanyQuestion({ answerValues: newChoiceCode });
      }}
    />
  );
};
